define('social_sharing_flyout_hover.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('social_sharing_flyout_hover', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"social-sharing-flyout-hover-icons\" data-type=\"social-share-icons-hover\"></div>  ";
},"useData":true}, 'extensions/SC/Manor/3.6.0/', 'extensions/SC/Manor/3.6.0/', Handlebars);
});